/**
 * pdf.js data files served same-origin (vite.config.ts `pmt-pdfjs-data`; docs/offline.md): the predefined character
 * maps (CJK and other CMap-encoded text) and the standard font data (PDFs that do not embed their fonts). Copied
 * from pdfjs-dist into /assets/pdfjs-<version>/; the service worker precaches the standard fonts and caches each cmap
 * on first use (docs/offline.md), so such PDFs render offline (a CJK one after one online open) and no CDN is involved. Pass pdfjs's own `version` so the path always matches the bundled library.
 */
export interface PdfjsAssetOptions {
    cMapUrl: string;
    cMapPacked: true;
    standardFontDataUrl: string;
}

export function pdfjsAssetOptions(version: string): PdfjsAssetOptions {
    const root = `/assets/pdfjs-${version}`;
    return { cMapUrl: `${root}/cmaps/`, cMapPacked: true, standardFontDataUrl: `${root}/standard_fonts/` };
}
